import React from 'react';
import { useIntl } from 'react-intl';

import { DateLozenge } from '@atlaskit/date';

import { HeightAdjustedContainer } from './HeightAdjustedContainer.tsx';

interface DateColumnProps {
	taskId: string;
	date?: Date | string;
}

export const DateColumn = ({ taskId, date }: DateColumnProps) => {
	const intl = useIntl();

	if (!date) return null;

	const today = new Date().getTime();
	const dateValue = new Date(date).getTime();
	const formattedDate = intl.formatDate(dateValue, {
		timeZone: 'UTC',
		month: 'short',
		day: 'numeric',
		year: 'numeric',
		formatMatcher: 'best fit',
	});

	// NOTE: DateLozenge handles dark/light internally
	return (
		<HeightAdjustedContainer taskId={taskId}>
			<DateLozenge color={dateValue < today ? 'red' : 'grey'}>{formattedDate}</DateLozenge>
		</HeightAdjustedContainer>
	);
};
